import { addMinutes, differenceInMinutes } from 'date-fns'

interface HorarioSelecionado {
  inicial: Date
  final: Date | undefined
}

interface HorarioNoDia {
  inicial: Date | undefined
  final: Date | undefined
}

interface SlotDoDia {
  duracao: number
}

/**
 * Retorna, no dia carregado, o slot com a mesma hora e minuto do horário inicial e devolve o par
 * inicial/final desse dia, mantendo a duração original entre eles.
 *
 * Exemplo: horário inicial 01/01 08:00, dia carregado 02/01 com um slot às 08:00 deve retornar
 * 02/01 08:00. O horário final é reposicionado pela mesma duração do par original (ou pela duração do slot, se não
 * houver final).
 *
 * @param horarioSelecionado Par inicial/final atual. Sem final, usa a duração do próprio slot encontrado.
 * @param slotsDoDia Slots do dia carregado, indexados pelo horário inicial de cada um.
 * @returns O par traduzido para o dia carregado, ou os dois `undefined` se esse dia não tiver um slot no
 * mesmo horário do inicial.
 */
export const getHorariosNoDia = (
  horarioSelecionado: HorarioSelecionado,
  slotsDoDia: Map<Date, SlotDoDia>
): HorarioNoDia => {
  const { inicial, final } = horarioSelecionado

  for (const [horarioDoDia, { duracao }] of slotsDoDia) {
    if (horarioDoDia.getHours() === inicial.getHours() && horarioDoDia.getMinutes() === inicial.getMinutes()) {
      const duracaoEmMinutos = final ? differenceInMinutes(final, inicial) : duracao

      return { inicial: horarioDoDia, final: addMinutes(horarioDoDia, duracaoEmMinutos) }
    }
  }

  return { inicial: undefined, final: undefined }
}
